<script>
import { mapActions, mapMutations, mapState } from "vuex";
import SnapshotFeature from "./SnapshotFeature.vue";
import trackAction from '@/utils/action';
import ContactAgentDialog from "../common/contactAgentDialog.vue";
import loadingSkeleton from "../package/loadingSkeleton.vue";

export default {
  name: "searchResults",
  components: { loadingSkeleton, ContactAgentDialog, SnapshotFeature },
  data() {
    return {
      adPage: "U-Display Listings Page",
      adSuburbs: "",
      adsData: "",
      curPage: 1,
      pageSize: 15,
      locallist: "",
      isLoading: true,
      apartment: "Apartments",
      townhouse: "Townhouses",
      house: "House",
      houseLand: "House & Land",
      landOnly: "Land",
      emptySearchResults: "",
      contactDialogVisible: false,
      searchFiltersForm: {
        sort: "time",
        suburbOrCity: "",
        saleType: "1",
        propertyTypeList: ["Any"],
        minPrice: "Any",
        maxPrice: "Any",
        minRentalEstimate: "Any",
        maxRentalEstimate: "Any",
        minLandSize: "Any",
        maxLandSize: "Any",
        minBuildSize: "Any",
        maxBuildSize: "Any",
        minBedrooms: "Any",
        maxBedrooms: "Any",
        bathrooms: "Any",
        carSpaces: "Any"
      },
      filterOptions: [
        {
          value: "time",
          label: "Newest to oldest listed"
        },
        {
          value: "timeasc",
          label: "Oldest to newest listed"
        },
        {
          value: "price",
          label: "Lowest to highest price"
        },
        {
          value: "pricedsc",
          label: "Highest to lowest price"
        }
      ],
      selectedFilterOption: "Newest to oldest listed"
    };
  },
  computed: {
    ...mapState({
      list: state => state.home.list
    })
  },
  beforeUpdate() {
    document.title = "UNIFI Property: Search Properties";
  },
  methods: {
    showSelectedProperty() {
      this.$router.push({ path: "/property-details/view" });
    },
    ...mapActions("home", [
      "getList",
      "getAds",
      "sign",
      "agree",
      "postCollect",
      "cancelCollect"
    ]),
    ...mapMutations("home", ["setList"]),
    filterList(txt) {
      console.log(
        "sessionStorage.searchFiltersForm **",
        sessionStorage.searchFiltersForm
      );
      let options = sessionStorage.searchFiltersForm
        ? JSON.parse(sessionStorage.searchFiltersForm)
        : this.searchFiltersForm;
      var that = this;
      var quest_params = {
        searchTerm: options.searchSuburb,
        sort: options.sort,
        searchType: options.searchType
      };

      if (options.propertyTypeList.length !== 0) {
        quest_params.propertyTypeList = options.propertyTypeList;
      }

      if (options.propertyType !== "Any") {
        quest_params.proertyType = options.propertyType;
      }

      if (options.minPrice !== "Any") {
        quest_params.minPrice = options.minPrice;
      }
      if (options.maxPrice !== "Any") {
        quest_params.maxPrice = options.maxPrice;
      }

      if (options.minRentalEstimate !== "Any") {
        quest_params.rental = options.minRentalEstimate;
      }
      if (options.maxRentalEstimate !== "Any") {
        quest_params.maxRental = options.maxRentalEstimate;
      }

      if (options.minLandSize !== "Any") {
        quest_params.labdSize = options.minLandSize;
      }
      if (options.maxLandSize !== "Any") {
        quest_params.landSizeMax = options.maxLandSize;
      }

      if (options.minBuildSize !== "Any") {
        quest_params.buildSize = options.minBuildSize;
      }
      if (options.maxBuildSize !== "Any") {
        quest_params.buildSizeMax = options.maxBuildSize;
      }

      if (options.minBedrooms !== "Any") {
        quest_params.bedsNumber = options.minBedrooms;
      }
      if (options.maxBedrooms !== "Any") {
        quest_params.bedsNumberMax = options.maxBedrooms;
      }

      if (options.bathrooms !== "Any") {
        quest_params.bathroomsNumber = options.bathrooms;
      }

      if (options.carSpaces !== "Any") {
        quest_params.carSpacesNumber = options.carSpaces;
      }
      that.getList({
        params: {
          page: this.curPage,
          pageSize: this.pageSize,
          other: quest_params
        },
        callback: that.callback
      });
    },
    loadMore(pageSize) {
      //this adds extra lists to the search results, if pagination is required, then update this.curPag
      //this.curPage++
      this.pageSize = pageSize
        ? pageSize
        : (this.pageSize = this.pageSize + 15);
      this.filterList();
    },
    getAdsbyPageAndSuburb() {
      let body_params = {
        adPage: this.adPage,
        adSuburbs: this.adSuburbs
      };
      this.getAds({ params: { other: body_params }, callback: this.callback2 });
    },
    goPropertyDetails(query) {
      trackAction("Details Clicks", {
        "actionCount": 1,
        "duration": 0,
        "elementAction": "Details Clicks",
        "elementName": "",
        "endTime": 0,
        "propertyId": query,
        "startTime": 0
      });
      this.$router.push({
        path: "/property-details/view",
        query: { pid: query }
      });
    },

    callback(res) {
      var that = this;
      that.$box.loadings(2);
      if (res.data.code == 0) {
        var datum = res.data.data;
        const searchAction = datum.list.map((item) => {
          return {
            "actionCount": 1,
            "duration": 0,
            "elementAction": "Search Results",
            "elementName": "",
            "endTime": 0,
            "propertyId": item.propertyId,
            "startTime": 0
          }
        })
        trackAction('list', searchAction)
        datum.list.forEach(v => {
          v.price = that.$box.formatSplit(v.price, true);
          v.rental = that.$box.formatSplit(v.rental, true);
          v.commision = that.$box.formatSplit(parseInt(v.commission), true);
          v.maxRental =
            v.maxRental !== 0 ? that.$box.formatSplit(v.maxRental, true) : null;
          v.maxPrice =
            v.maxPrice !== "" ? that.$box.formatSplit(v.maxPrice, true) : "";
          v.maxCommision =
            v.maxCommision !== ""
              ? that.$box.formatSplit(parseInt(v.maxCommision), true)
              : "";
          v.landPrice =
            v.landPrice !== "" ? that.$box.formatSplit(v.landPrice, true) : "";
          v.buildPrice =
            v.buildPrice !== ""
              ? that.$box.formatSplit(v.buildPrice, true)
              : "";
          v.landPriceMax =
            v.landPriceMax !== ""
              ? that.$box.formatSplit(v.landPriceMax, true)
              : "";
          v.buildPriceMax =
            v.buildPriceMax !== ""
              ? that.$box.formatSplit(v.buildPriceMax, true)
              : "";
          v.clickFlag = true;

          if (v.imageUrl.indexOf(",") !== -1) {
            v.imgLst = v.imageUrl.split(",");
            v.imgFirst = v.imgLst[0];
          } else {
            v.imgLst = [v.imageUrl];
            v.imgFirst = v.imageUrl;
          }
        });

        that.completeSearch = false;
        that.welcomeText = datum.welcomeName;
        that.emptySearchResults = datum.emptySearchResults;
        this.locallist = datum.list;
        this.getAdsbyPageAndSuburb();
        that.isLoading = false;
      } else if (
        res.data.code == 90000 ||
        res.data.code == 90002 ||
        res.data.code == 90001
      ) {
        localStorage.clear();
        that.isLoading = true;
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.isLoading = false;
        that.$router.push("/login");
      } else {
        that.isLoading = false;
        that.$box.alert("", res.data.message, "error");
      }
    },
    callback2Old(resp) {
      if (resp.data.code == 0) {
        this.adsData = resp.data.data;
        // assuming there are 8 ads in total, then can insert into the following indexes.
        const adIndices = [2, 5, 8];
        for (let i = 0; i < adIndices.length; i++) {
          const adNumber = i + 1;
          const adIndex = this.locallist.findIndex(
            ad => ad.adNumber === adNumber
          );
          if (adIndex === -1) {
            this.locallist.splice(adIndices[i] + i, 0, {
              adImageUrl: this.adsData[`udisplayListingsMobile${adNumber}`],
              adImageUrlClick: this.adsData[`udisplayListings${adNumber}Click`],
              adNumber
            });
          }
        }
      }
    },
    callback2(resp) {
      if (resp.data.code === 0) {
        this.adsData = resp.data.data;

        const adIndices = [2, 5, 8];
        adIndices.forEach((index, i) => {
          const adNumber = i + 1;
          if (!this.locallist.some(ad => ad.adNumber === adNumber)) {
            this.locallist.splice(index + i, 0, {
              adImageUrl: this.adsData[`udisplayListingsMobile${adNumber}`],
              adImageUrlClick: this.adsData[`udisplayListings${adNumber}Click`],
              adNumber
            });
          }
        });

        console.log("****** list.list *******", this.locallist);
      }
    },
    collect(data) {
      this.locallist.find(v => {
        if (v.propertyId == data.data.id) {
          if (data.data.type == "no") {
            v.favoritesFlag = "yes";
          } else {
            v.favoritesFlag = "no";
          }
        }
      });
    },
    collectOperate(type, id) {
      var that = this;
      console.log("collectOperate", type);
      console.log("collectOperate id :", id);

      if (type == null) {
        that.$router.push({ name: "newloginpage" });
      }

      if (type == "no") {
        that.postCollect({
          params: { propertyId: id },
          callback: that.collcectCallback
        });
        trackAction("Favourited", {
          "actionCount": 1,
          "duration": 0,
          "elementAction": "Favourited",
          "elementName": "",
          "endTime": 0,
          "propertyId": id,
          "startTime": 0
        });
      } else {
        that.cancelCollect({
          params: { propertyId: id },
          callback: that.cancelCallback
        });
      }
    },
    collcectCallback(res, id) {
      var that = this;
      if (res.data.code == 0) {
        that.collect({ data: { type: "no", id: id } });
        that.$forceUpdate();
      } else if (
        res.data.code == 90000 ||
        res.data.code == 90002 ||
        res.data.code == 90001
      ) {
        localStorage.clear();
        that.$router.push({ name: "newloginpage" });
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push({ name: "newloginpage" });
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    },
    cancelCallback(res, id) {
      console.log("cancelCallback id :", id);
      var that = this;
      if (res.data.code == 0) {
        that.collect({ data: { type: "yes", id: id } });
        that.$forceUpdate();
      } else if (
        res.data.code == 90000 ||
        res.data.code == 90002 ||
        res.data.code == 90001
      ) {
        localStorage.clear();
        that.$router.push({ name: "newloginpage" });
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push({ name: "newloginpage" });
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    },
    goAdLink(query) {
      window.open(query, "_blank");
    },
    getLandSizeValue(size, sizeMax) {
      if (
        (size == null && sizeMax == null) ||
        (size == 0 && sizeMax == 0) ||
        (size == "" && sizeMax == "") ||
        (size == 0 && sizeMax == null) ||
        (size == null && sizeMax == 0)
      ) {
        return "TBA";
      } else if (parseFloat(size) > 0 && sizeMax == null) {
        return size + " m\u00B2";
      } else if (parseFloat(size) > 0 && parseFloat(sizeMax) > 0) {
        return size + " m\u00B2" + " - " + sizeMax + " m\u00B2";
      } else if (size == null && parseFloat(sizeMax) > 0) {
        return sizeMax + " m\u00B2";
      } else {
        return parseFloat(size) > parseFloat(sizeMax)
          ? size + " m\u00B2"
          : size + " m\u00B2" + " - " + sizeMax + " m\u00B2";
      }
    },
    getAdId(advertisementId) {
      switch (advertisementId) {
        case 1:
          return "uDisplayListingPagePenthouse";
        case 2:
          return "uDisplayListingPageMezzanine";
        case 3:
          return "uDisplayListingPageElevator";
      }
    },
    shareAction() { },
    generateAgentNameColour(companyColor) {
      if (companyColor == null || companyColor == "") {
        companyColor = "#FFFFFF";
      }
      var c = companyColor.substring(1);      // strip #
      var rgb = parseInt(c, 16);   // convert rrggbb to decimal
      var r = (rgb >> 16) & 0xff;  // extract red
      var g = (rgb >> 8) & 0xff;  // extract green
      var b = (rgb >> 0) & 0xff;  // extract blue

      var luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709

      if (luma < 40) {
        // pick a different colour
        return "#ffffff";
      } else {
        // Check if the color is a variant of green
        var isGreenVariant = g > r && g > b;
        return isGreenVariant ? "#ffffff" : "#003333";
      }
    },
    selectNow(propertyId) {
      this.$router.push({ path: '/property/reservation', query: { pid: propertyId, type: 2 } })
    },
    contactAgent() {
      this.contactDialogVisible = true;
    },
    generateDisplayAddress(address, suburb) {
      var dAddress = address ? address.trim() : "TBA";
      var dSuburb = suburb ? suburb : "TBA";
      return dAddress + " | " + dSuburb;
    },
    generateDisplayStateAndPostcode(state, postcode) {
      var dState = state ? state : "TBA";
      var dPostcode = postcode ? postcode : "TBA";
      return dState + " | " + dPostcode;
    },
    getAgentAvatarSize() {
      switch (true) {
        case window.windowWidth < 600:
          return 30;
          break;
        case window.windowWidth < 1024:
          return 40;
          break;
        default:
          return 60;
          break;
      }
    },
    isWithinLastTenDays(launched) {
      const launchDate = new Date(launched);
      const now = new Date();
      const diffTime = now - launchDate;
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      return diffDays <= 10 && diffDays >= 0;
    }
  },
  mounted() {
    this.filterList();
  }
};
</script>

<template>
  <div>
    <loading-skeleton v-if="isLoading" :loading-text="'Searching...'" />
    <div v-else>
      <h1 v-if="this.emptySearchResults == 'yes'" class="no-results">
        No properties have been found in this area. Please see surrounding
        suburbs.
      </h1>
      <div v-for="item in this.locallist" :key="item.id" style="padding: 10px 0">
        <el-row v-if="item.adImageUrl" style="padding: 40px 0 40px 0; background-color: #ffffff">
          <el-col :span="24" style="display: flex; justify-content: center">
            <img :id="getAdId(item.adNumber)" :src="item.adImageUrl" class="ads" loading="lazy"
              style="width: 92.5%;  object-fit: cover" @click="goAdLink(item.adImageUrlClick)" />
          </el-col>
        </el-row>
        <el-row v-else style="display: flex; padding: 0 16px">
          <el-col :span="24" style="cursor: pointer">
            <el-row class="search-result-wrapper">
              <el-col :span="24" class="container"
                style="display: flex; justify-content: center; background-color: #ffffff; overflow: hidden">
                <span v-if="isWithinLastTenDays(item.launchDate)" @click="goPropertyDetails(item.propertyId)" class="brand-new-listing">Brand New Listing</span>
                <span v-if="item.availableRooms > 0 && item.availableRooms < 5" @click="goPropertyDetails(item.propertyId)" class="remaining-properties">Only {{item.availableRooms}} Remaining...</span>
                <el-image :fit="'cover'" :src="item.imgFirst" style="height: 100%; width: 100%"
                  @click="goPropertyDetails(item.propertyId)" />
              </el-col>
              <el-row>
                <el-col :span="24" :style="'background-color:' + item.companyColour + ';'">
                  <el-row style="display: flex; justify-content: space-between">
                    <el-col :span="12">
                      <img :fit="'fill'" :src="item.companyLogoUrl" class="agency-logo"
                        @click="goPropertyDetails(item.propertyId)" />
                    </el-col>
                    <el-col :span="12">
                      <el-row>
                        <el-col :span="16" class="agent-name-wrapper">
                          <el-row style="display: flex; align-items: center; justify-content: center"><span
                              class="agent-name-style"
                              :style="'color:' + generateAgentNameColour(item.companyColour) + ';'">{{
                                item.firstName1 + ' ' + item.lastName1
                              }}</span></el-row>
                        </el-col>
                        <el-col :span="8">
                          <el-avatar :src="item.imageUrl1" class="agent-img"></el-avatar>
                        </el-col>
                      </el-row>

                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
              <el-col :span="24" style="display: flex;">
                <el-card shadow="never" class="card-style">
                  <el-col :span="24" style="padding-left: 10px">
                    <div @click="goPropertyDetails(item.propertyId)" style="z-index: -1">
                      <el-row :gutter="20">
                        <el-col :span="24">
                          <el-row style="margin-bottom: 5px">
                            <el-col :span="12" stype="padding-top: 20px">
                              <span class="property-type-chip">{{
                                item.proertyType
                                }}</span>
                            </el-col>
                          </el-row>
                          <el-row>
                            <el-col :span="24"
                              style="display: flex; flex-direction: column; justify-content: space-between">
                              <el-row>
                                <el-col :span="18"
                                  style="display: flex; flex-direction: column; justify-content: flex-start; padding-left: 12px">
                                  <el-row>
                                    <!--                              Address Start-->
                                    <el-col :span="24">
                                      <el-row>
                                        <el-col :span="24"
                                          style="display: flex; flex-direction: row; justify-content: space-between">
                                          <span class="div-suburb omit">{{ generateDisplayAddress(item.address,
                                            item.suburb) }}</span>
                                        </el-col>
                                      </el-row>
                                      <el-row>
                                        <el-col :span="24">
                                          <span class="div-state">{{ generateDisplayStateAndPostcode(item.state,
                                            item.postcode) }}</span>
                                        </el-col>
                                      </el-row>
                                    </el-col>
                                    <!--                          Address End-->
                                  </el-row>
                                </el-col>
                                <el-col :span="6"
                                  style="padding: 0 12px; display: flex; justify-content: flex-end; z-index: 5">
<!--                                  <el-row>-->
<!--                                    <div v-if="item.favoritesFlag == null || item.favoritesFlag == 'no'"-->
<!--                                      class="fav-icon-start" v-track:103.click="{ shareAction, pid: item.propertyId }">-->
<!--                                      <el-image @click.stop="collectOperate(item.favoritesFlag, item.propertyId)"-->
<!--                                        class="fav-icon" :src="require('../../assets/star.svg')" />-->
<!--                                    </div>-->
<!--                                    <div v-else class="fav-icon-start">-->
<!--                                      <el-image @click.stop="collectOperate(item.favoritesFlag, item.propertyId)"-->
<!--                                        class="fav-icon" :src="require('../../assets/star-fill.svg')" />-->
<!--                                    </div>-->
<!--                                  </el-row>-->
                                </el-col>
                              </el-row>
                              <el-row>
                                <el-col :span="24"
                                  style="padding: 12px; display: flex; justify-content: flex-start;padding-left: 12px">
                                  <el-row :gutter="20">
                                    <el-col :span="24">
                                      <el-row>

                                        <!--Price of Land Start-->
                                        <el-col v-if="item.price == 0 && item.price == 0" :span="24"
                                          class="price-style">
                                          Make an offer
                                        </el-col>
                                        <el-col v-else :span="24" class="price-style">
                                          {{
                                            item.price != 0
                                              ? "$" + item.price
                                              : ""
                                          }}
                                          {{
                                            item.maxPrice != 0
                                              ? " - $" + item.maxPrice
                                              : ""
                                          }}
                                        </el-col>
                                        <!--Price of Land End-->
                                      </el-row>
                                    </el-col>
                                  </el-row>
                                </el-col>
                              </el-row>
                              <el-row>
                                <el-col :span="24" class="property-description-wrapper">
                                  <el-row>
                                    <el-col :span="24">
                                      <snapshot-feature v-if="item.proertyType == landOnly"
                                        :feature="item.estimatedSettled" :feature-text="'Estimated Settlement'"
                                        :property-type="item.proertyType" />
                                    </el-col>
                                  </el-row>
                                  <el-row>
                                    <el-col :span="24">
                                      <snapshot-feature v-if="item.proertyType == landOnly" :feature="item.titlesIssued"
                                        :feature-text="'Title Issued'" :property-type="item.proertyType" />
                                    </el-col>
                                  </el-row>
                                  <el-row>
                                    <el-col :span="24">
                                      <snapshot-feature v-if="item.proertyType == landOnly"
                                        :feature="getLandSizeValue(item)" :feature-text="'Land Size'"
                                        :property-type="item.proertyType" />
                                    </el-col>
                                  </el-row>
                                  <el-row>
                                    <el-col :span="24">
                                      <snapshot-feature v-if="item.proertyType == apartment ||
                                        item.proertyType == houseLand ||
                                        item.proertyType == townhouse ||
                                        item.proertyType == house" :feature="item.estimatedCommenceMent"
                                        :feature-text="'Estimated Commencement'" :property-type="item.proertyType" />
                                    </el-col>
                                  </el-row>
                                  <el-row>
                                    <el-col :span="24">
                                      <snapshot-feature v-if="
                                        item.proertyType == apartment ||
                                        item.proertyType == houseLand ||
                                        item.proertyType == townhouse ||
                                        item.proertyType == house" :feature="item.estimatedCompletion"
                                        :feature-text="'Estimated Completion'" :property-type="item.proertyType" />
                                    </el-col>
                                  </el-row>
                                  <el-row>
                                    <el-col :span="24">
                                      <snapshot-feature :feature="item.contractType" :feature-text="'Contract Type'"
                                        :property-type="item.proertyType" />
                                    </el-col>
                                  </el-row>
                                  <el-row>
                                    <el-col :span="24">
                                      <snapshot-feature :feature="item.incentives" :feature-text="'Incentives'"
                                        :property-type="item.proertyType" />
                                    </el-col>
                                  </el-row>
                                </el-col>
                              </el-row>
                              <el-row>
                                <el-col :span="24" style="padding: 0 12px ; display: flex; justify-content: flex-start">
                                  <el-row :gutter="20" style="width: 100%;">

<!--                                    <el-col :span="12"-->
<!--                                      style="padding: 12px; display: flex; justify-content: flex-end; z-index: 5">-->
<!--                                      <el-button class="btn-primary select-now-btn"-->
<!--                                        v-track:101.click="{ shareAction, pid: item.propertyId }"-->
<!--                                        @click.stop="selectNow(item.propertyId)">Reserve Now</el-button>-->
<!--                                    </el-col>-->
                                    <el-col :span="12" :offset="12" style="padding: 12px; display: flex; justify-content: flex-end">
                                      <el-button class="btn-primary contact-agent-btn"
                                                 @click.stop="contactAgent">Contact Agent</el-button>
                                    </el-col>
                                  </el-row>
                                </el-col>
                              </el-row>
                              <el-row>
                              </el-row>
                            </el-col>
                          </el-row>
                        </el-col>
                      </el-row>
                    </div>
                  </el-col>
                </el-card>
              </el-col>
            </el-row>
          </el-col>
          <!-- Contact Agent Dialog-->
          <contact-agent-dialog v-if="contactDialogVisible"
                                :contact-dialog-visible.sync="contactDialogVisible"
                                :property-id="item.propertyId"></contact-agent-dialog>
        </el-row>
      </div>
    </div>
  </div>
</template>

<style scoped>
.search-result-wrapper {
  display: flex;
  flex-direction: column;
  box-shadow: 8px 10px 5px 6px #cccccc;
  border: 1px solid #003333;
  border-radius: 0 0 15px 15px;
}

.card-style {
  background-color: #ffffff;
  border-width: 0;
  border-radius: 0 0 15px 15px;
  height: 500px;
  width: 100%;
  padding: 20px 0;
}

.fav-icon-start {
  margin-top: 20px;
}

.agency-logo {
  max-width: 100%;
  max-height: 30px;
  padding: 5px;
}

.agent-name-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  height: 40px;
  min-height: 40px;
}

.agent-name-style {
  color: #585858;
  font-feature-settings: "clig" off, "liga" off;
  font-family: DINosaur-a;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  display: flex;
  align-self: center;
  padding-right: 10px;
}

.agent-img {
  display: flex;
  z-index: 1;
  position: absolute;
  bottom: -.2rem;
  right: .2rem;
  border: 2px solid #003333;
}

.agent-img>img {
  min-width: 50px;
  object-fit: cover;
}

.property-type-chip {
  color: #003333;
  font-feature-settings: "clig" off, "liga" off;
  white-space: nowrap;
  justify-content: center;
  border-radius: 37px;
  background-color: #cccccc;
  align-self: start;
  padding: 10px 20px;
  font: 400 10px/125% DINosaur-a, sans-serif;
}

.div-suburb {
  color: #003333;
  font-feature-settings: "clig" off, "liga" off;
  align-self: stretch;
  margin-top: 20px;
  font: 600 18px DINosaur-a, sans-serif;
}

.div-state {
  color: #003333;
  font-feature-settings: "clig" off, "liga" off;
  margin: auto 0;
  font: 400 18px/111% DINosaur-a, sans-serif;
}

.container {
  position: relative;
  height: 230px;
}

.container .main-render {
  display: block;
}

.container .fav-icon {
  position: absolute;
  width: 24px;
  height: 24px;
}

.container .fav-icon-circle {
  position: absolute;
  top: 12px;
  right: 20px;
  border-radius: 100px;
  background: rgba(255, 255, 255, 0.75);
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.container .fav-icon-circle-filled {
  position: absolute;
  top: 12px;
  right: 20px;
  border-radius: 100px;
  background: #101010;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.desc-style {
  color: #000;
  margin-top: 5px;
  text-align: start;
  font-feature-settings: "clig" off, "liga" off;
  font: 400 16px Metropolis, sans-serif;
  line-height: 20px;
}

.price-style {
  color: #003333;
  margin-top: 5px;
  text-align: start;
  font-feature-settings: "clig" off, "liga" off;
  font: 500 18px DINosaur-a, sans-serif;
  line-height: 20px;
  display: flex;
  justify-content: flex-end;
}

.btn-primary {
  font-family: DINosaur-a, sans-serif;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  min-width: 100%;
  width: 100%;
  border: 4px solid #003333;
  background-color: #003333;
  color: #ffffff;
  padding: 10px 0;

}

.select-now-btn {
  //padding-left: 20px;
  //padding-left: 20px;
}

.el-card /deep/ .el-card__header {
  padding: 0 !important;
}

.el-card /deep/ .el-card__body {
  padding: 0 !important;
}

.omit {
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
}


.no-results {
  color: #003333;
  font-feature-settings: "clig" off, "liga" off;
  font-family: DINosaur-a;
  font-size: 30px;
  font-style: normal;
  font-weight: 400;
  padding-right: 20px;
  padding-left: 20px;
  padding-bottom: 30px;
  text-align: center;
}

.ads {
  size: 90%;
}

.agent-img {
  width: 50px;
  height: 50px;
}



.omit1 {
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
}

.property-description-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-left: 12px;
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .card-style {
    height: 500px;
    width: 100%;
    padding: 20px 0;
  }

  .contact-agent-btn {
    font-size: 9px;
  }

  .select-now-btn {
    font-size: 9px;
  }

  .agency-logo {
    max-height: 20px;
  }

  .agent-img {
    width: 45px;
    height: 45px;
  }

  .agent-name-wrapper {
    height: 30px;
    min-height: 30px;
  }

  .agent-name-style {
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
  }

  .property-description-wrapper {
    min-height: 200px;
  }

}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .search-result-wrapper {
    box-shadow: 4px 5px 5px 3px #cccccc;
  }

  .card-style {
    height: 400px;
    width: 100%;
    padding: 20px 0;
  }

}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .search-result-wrapper {
    box-shadow: 5px 6px 5px 4px #cccccc;
  }

  .card-style {
    height: 400px;
    width: 100%;
    padding: 20px 0;
  }

  .agent-img {
    width: 60px;
    height: 60px;
  }
}


.remaining-properties {
  color: white;
  background-color: red;
  padding: 10px 15px;
  position: absolute;
  z-index: 1;
  top: 10px;
  right: 10px;
  font-size: 12px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  text-align: center;
  min-width: max-content;
  transform: translateZ(0);
  opacity: 0.8;
}

.remaining-properties:hover {
  transform: translateZ(0) scale(1.02);
  transition: transform 0.2s ease;
}

.brand-new-listing {
  color: white;
  background-color: red;
  padding: 10px 15px;
  position: absolute;
  z-index: 1;
  top: 10px;
  left: 10px;
  font-size: 12px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  text-align: center;
  min-width: max-content;
  transform: translateZ(0);
  opacity: 0.8;
}

.brand-new-listing:hover {
  transform: translateZ(0) scale(1.02);
  transition: transform 0.2s ease;
}


/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .card-style {
    height: 380px;
    width: 100%;
    padding: 20px 0;
  }

  .agent-img {
    width: 70px;
    height: 70px;
  }

  .agent-name-style {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/search/searchResults.vue